"use client";

import { useSetAtom } from "jotai";

import { Button } from "@/components/ui/button";

import { showLoginAtom } from "@/store/auth";

function LoginButton({ ...props }) {
  const setShowLogin = useSetAtom(showLoginAtom);

  return (
    <Button onClick={() => setShowLogin(true)} {...props}>
      Login/Signup
    </Button>
  );
}

export default LoginButton;
